'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyOrIndexToIndex = require('./keyOrIndexToIndex');

var _keyOrIndexToIndex2 = _interopRequireDefault(_keyOrIndexToIndex);

var _wrapNumber = require('./wrapNumber');

var _wrapNumber2 = _interopRequireDefault(_wrapNumber);

var _size = require('unmutable/lib/size');

var _size2 = _interopRequireDefault(_size);

var _swap = require('unmutable/lib/swap');

var _swap2 = _interopRequireDefault(_swap);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    return function (parcelData) {

        var indexA = (0, _keyOrIndexToIndex2.default)(key)(parcelData);
        var indexB = (0, _wrapNumber2.default)(indexA + 1, (0, _size2.default)()(parcelData.value));

        return (0, _pipeWith2.default)(parcelData, (0, _update2.default)('value', (0, _swap2.default)(indexA, indexB)), (0, _update2.default)('child', (0, _swap2.default)(indexA, indexB)));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/swapNext.js
// module id = 756
// module chunks = 35783957827783